// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React /* eslint-disable-line no-unused-vars */, {
  Fragment,
  type Node,
} from 'react';

import {
  Button,
  Colors,
  Heading,
  Img,
  Spacer,
  Text,
  Typography,
} from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

import { type Size } from '@zapier/design-system-company';

/** @jsx isolateComponent */

type Props = {
  /** The main content of the topic */
  children: Node,
  /** Image alt text */
  imageAlt: string,
  /** Image source */
  imageSrc: string,
  /** Callback to be executed when the button is clicked */
  onButtonClick: (e: SyntheticMouseEvent<*>) => void,
  /** Size */
  size: Size,
  /** Content title */
  title: string,
};

const Styles = labelStyles(__filename, {
  buttonWrapper: {
    textAlign: 'center',
  },

  heading: {
    ...Typography.subtitle900,
    color: Colors.grey900,
  },
});

const TrialWelcomeModalTopicView = (props: Props) => (
  <Fragment>
    <Img alt={props.imageAlt} hasRadius={false} src={props.imageSrc} />

    <Spacer height={25} />

    <Heading css={Styles.heading}>{props.title}</Heading>

    <Spacer height={25} />

    <Text color="grey900" tag="p" type="bodyText900">
      {props.children}
    </Text>

    <Spacer height={20} />

    <div css={Styles.buttonWrapper}>
      <Button
        casing="uppercase"
        hasShadow={true}
        isFullWidth={props.size === 'small'}
        onClick={props.onButtonClick}
      >
        Back
      </Button>
    </div>
  </Fragment>
);

export default TrialWelcomeModalTopicView;
